export const menuData = [
    {
        name: 'Accounting', icon: 'iconssc-accounting', isActive: false, Child:
            [
                { id: 1, name: 'AccountManag' },//ادارة الحسابات
                { id: 2, name: 'AddTeller' },//تعريف امين صندوق
                { id: 12, name: 'FrmExchCommPrice' },//شرائح الاجور
                { id: 3, name: 'DailyOperation' },//العمليات اليومية
                { id: 20, name: 'AgentsOperations' },//عمليات الوكيل
                { id: 4, name: 'DailyReports' },//التقارير اليومية
                { id: 5, name: 'ChecksBanking' },//الشيكات
                { id: 6, name: 'AccQueries' },//الكشوف المحاسبية
                { id: 7, name: 'FinancialStatements' },//القوائم المالية
                { id: 8, name: 'QueriesStatic' },//الاستعلامات الاحصائية
                { id: 9, name: 'PrivateQueries' },//استعلامات خاصة
                { id: 10, name: 'FinalAccCloseFinancialSession' },//الحسابات الختامية واقفال الدورة المالية
                { id: 11, name: 'Analysis' },//تحليل مالي
                { id: 15, name: 'ProfitsCur' },//
                { id: 13, name: 'FrmForexTradingProfits' },//
                { id: 14, name: 'FrmListIncomeResult' },//
            ]
    },
    //ادارة الوكلاء
    {
        name: 'AgentSettings', icon: 'iconssc-management', isActive: false, Child:
            [
                { id: 50, name: 'DefinitionOf' },//ادارة الوكلاء
                { id: 51, name: 'Confirm' },//ادارة الوكلاء
                { id: 52, name: 'Queries' },//ادارة الوكلاء
                { id: 53, name: 'QueriesStatic' },//ادارة الوكلاء
                { id: 54, name: 'FrmRemitt_PayComm' },//ادارة الوكلاء
                { id: 55, name: 'FrmControlPanelAgent' },//ادارة الوكلاء
                { id: 56, name: 'FrmAgentCurrSettingsPanel' },//ادارة الوكلاء
            ]
    },
    //ادارة العملاء
    {
        name: 'ClientManag', icon: 'iconssc-management', isActive: false, Child:
            [
                { id: 100, name: 'Management' },//بطاقة العميل
                { id: 101, name: 'Compliance' },//ادارة الوكلاء
                { id: 102, name: 'Complaints' },//ادارة الوكلاء
                { id: 103, name: 'Setting' },//ادارة الوكلاء
                { id: 104, name: 'Confirm' },//ادارة الوكلاء
                //{ id: 103, name: 'FrmControlPanelClient' },//ادارة الوكلاء
            ]
    },
    //الحوالات 
    {
        name: 'Remittances', icon: 'iconssc-remittances', isActive: false, Child:
            [
                { id: 31, name: 'Opretions' },//العمليات
                { id: 32, name: 'QuickRemitt' },//الحوالات السريعة
                { id: 33, name: 'ImportFinances' },//تمويل الاستيراد
                { id: 35, name: 'FrmAddRemttOrderUpdate' },//استعلام حالة الحوالة
                { id: 36, name: 'FrmRemittStatusGeneral' },//استعلام حالة الحوالة عام
                { id: 37, name: 'FollowUpRemitt' },//متابعة الحوالات
                { id: 38, name: 'GeneralQueries' },//استعلامات عامة
                { id: 39, name: 'QueriesStatic' },//استعلامات احصائية
                { id: 40, name: 'HelpWindows' },//نوافذ مساعدة
                { id: 41, name: 'InterRemittStat' },//كشوف الحوالات الداخلي
                { id: 43, name: 'TransferPoints' },//نقاط التحويل
            ]
    },
    //الحوالات السريعة 
    {
        name: 'QuickRemitt', icon: 'iconssc-remittances', isActive: false, Child:
            [
                { id: 70, name: 'RemRecApi' },//ارسال حوالة
                { id: 71, name: 'RemPayApi' },//تسديد حوالة
                { id: 72, name: 'FrmAddRemttOrderUpdate' },//استعلام حالة حوالة
                { id: 73, name: 'TransactionSearchApi' },//استعلام الحوالات الصادرة
                { id: 74, name: 'ManagementUsers' },//ادارة المستخدمين
                { id: 75, name: 'ApiErrorsQuery' },//استعلام الاخطاء
            ]
    },
    //الصرافة 
    {
        name: 'Exchange', icon: 'iconssc-exchange', isActive: false, Child:
            [
                { id: 60, name: 'SlicedWages' },//شرائح الاجور
                { id: 61, name: 'ExchOperations' },//العمليات
                { id: 62, name: 'PreciousMetalsOperat' },//عمليات الذهب
                { id: 63, name: 'FrmInvoiceSerch' },//استعلام  الفواتير
                { id: 64, name: 'FrmCenterlBankRptExch' },//كشوف المركزي
                { id: 65, name: 'FrmCommState' },//استعلام العمولات
                { id: 67, name: 'FrmExchPurchSales' },//مشتريات و مبيعات
                { id: 66, name: 'FrmExchOperatTeller' },//استعلام عمليات الصناديق
                { id: 68, name: 'Auctions' },//المزادات
            ]
    },//مستودعات
    {
        name: 'Stocks', icon: 'iconssc-settings', isActive: false, Child:
            [
                { id: 150, name: 'frmMatList' },
                { id: 151, name: 'ListStocks' },
                { id: 152, name: 'frmMatSalesman' },
                { id: 153, name: 'ExchOperations' },
                { id: 154, name: 'Queries' },
                { id: 155, name: 'ReportProfit' },
                { id: 156, name: 'frmMatOrders' },
            ]
    }, 
    //الامتثال
    {
        name: 'Compliance', icon: 'iconssc-compliance', isActive: false, Child:
            [
                { id: 90, name: 'FrmCardIdentity' },//بطاقة عميل
                { id: 91, name: 'Queries' },//بطاقة عميل
                { id: 96, name: 'GeneralStats' },//استعلامات احصائية
                { id: 92, name: 'Blacklists' },//استعلام عام عملاء
                { id: 97, name: 'FrmRiskDegreeSet' },//استعلام عام عملاء
                { id: 93, name: 'FrmCardSetting' },//بطاقة عميل
                { id: 94, name: 'FrmCustCardModifiReq' },//بطاقة عميل
                { id: 95, name: 'FrmSuspiciousTransactions' },//بطاقة عميل

            ]
    },//الشحن
    {
        name: 'Tran', icon: 'iconssc-upload', isActive: false, Child:
            [
                { id: 110, name: 'SlicedWages' },//
                { id: 111, name: 'FrmTrInvoiceIN' },//
                { id: 112, name: 'FrmTrAccInvoiceIN' },//
                { id: 113, name: 'Manafest' },//
                { id: 114, name: 'FrmTrInvoiceStore' },//
                { id: 116, name: 'LockFund' },//
                { id: 115, name: 'Navigation' },//
                { id: 117, name: 'Queries' },//
                { id: 120, name: 'FrmTrClosingWages' },//
                { id: 118, name: 'RemittancesAgainstPayment' },
                { id: 119, name: 'FrmTrInvoiceInStatus' },//
            ]
    },//بطاقات العراق
    {
        name: 'Cards', icon: 'iconssc-layers', isActive: false, Child:
            [
                { id: 125, name: 'FrmCardGroup' },//
                { id: 122, name: 'FrmSlicedWagesCards' },//
                { id: 123, name: 'ExchOperations' },//
                { id: 124, name: 'Queries' },//
            ]
    }, // الفنادق
    {
        name: 'Hotels', icon: 'iconssc-bank', isActive: false, Child:
            [
                { id: 130, name: 'FrmBuldRoomStatusStat' },
                { id: 131, name: 'Queries' },
                { id: 132, name: 'ExchOperations' },

            ]
    }, //ادوات
    {
        name: 'Tools', icon: 'iconssc-settings', isActive: false, Child:
            [
                { id: 82, name: 'ManagementCur' },//ادارة العملات 
                { id: 80, name: 'ManagementBranches' },//ادارة الفروع
                { id: 85, name: 'ManagementUsers' },//ادارة المستخدمين  
                { id: 83, name: 'HelpWindows' },//نوافذ مساعدة  
                { id: 86, name: 'FrmLogFile' },//ملف التسجيل  
                { id: 87, name: 'ReviewAudit' },//بطاقة عميل
                { id: 88, name: 'DesignReport' },//بطاقة عميل
                { id: 84, name: 'FrmOption' },//خيارات البرنامج  
                { id: 42, name: 'MobileAppManag' },//ادارة تطبيق الجوال
                { id: 81, name: 'FrmUserPassword' },//اعادة ضبط كلمة المرور     
            ]
    }, //ادارة
    {
        name: 'Management', icon: ' fa fa-toolbox my-1', isActive: false, Child:
            [
                { id: 140, name: 'SuppliesInventoryManag' },//ادارة مخزون اللوازم
                { id: 141, name: 'SalariesWages' },//الرواتب والاجور
            ]
    }
];